import formatPath from 'utils/formatPath';

const getPageType = (path, slug, isCategoryPage) => {
  if (isCategoryPage) {
    return 'PLP';
  }

  if (path === '/') {
    return 'home';
  }

  if (slug?.find(slug => /_\d+/.test(slug))) {
    return 'advertisement';
  }

  if (path === '/search') {
    return 'search';
  }

  return formatPath(path);
};

export default getPageType;
